import styled from 'styled-components'
import {
  Container as BaseContainer,
  CreateButtonDiv as BaseCreateButtonDiv,
  CreateButtonText as BaseCreateButtonText,
  DangerButtonDiv as BaseDangerButtonDiv,
  HeaderText as BaseHeaderText,
  InputDiv as BaseInputDiv,
  InputField as BaseInputField,
  LabelCreate as BaseLabelCreate,
  ModalActionsColumn as BaseModalActionsColumn,
  SelectField as BaseSelectField,
} from '../CreateAccessUserModal/style'

export const HeaderText = styled(BaseHeaderText)`
  font-size: 1.45rem;
`

export const LabelCreate = styled(BaseLabelCreate)`
  font-size: 0.82rem;
`

export const Container = styled(BaseContainer)`
  padding: 1.35rem 1.5rem;
  width: 42rem;
`

export const InputDiv = styled(BaseInputDiv)`
  gap: 0.35rem;
  margin-top: 0.75rem;
`

export const InputField = styled(BaseInputField)`
  height: 4.4vh;
  min-height: 2.25rem;
  font-size: 0.88rem;
  padding-left: 0.85vw;
  padding-right: 0.85vw;
  border-radius: 1.6vw;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #f3f4f6;
  }
`

export const SelectField = styled(BaseSelectField)`
  height: 4.4vh;
  min-height: 2.25rem;
  font-size: 0.88rem;
  padding-left: 0.85vw;
  padding-right: 0.85vw;
  border-radius: 1.6vw;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #f3f4f6;
  }
`

export const ModalActionsColumn = styled(BaseModalActionsColumn)`
  margin-top: 1.15rem;
  gap: 0.75rem;
`

export const CreateButtonDiv = styled(BaseCreateButtonDiv)`
  height: auto;
  min-height: 2.65rem;
  padding: 0.65rem 1.15rem;
  border-radius: 2.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CreateButtonText = styled(BaseCreateButtonText)`
  font-size: 0.85vw;
`

export const DangerButtonDiv = styled(BaseDangerButtonDiv)`
  min-height: 2.65rem;
  padding: 0.65rem 1.15rem;
  border-radius: 2.2vw;
  font-size: clamp(0.78rem, 0.88vw, 0.92rem);
`

export const ActivateButtonDiv = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.65rem;
  padding: 0.65rem 1.15rem;
  border: none;
  border-radius: 2.2vw;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.78rem, 0.88vw, 0.92rem);
  font-weight: 700;
  background-color: #22c55e;
  color: #fff;

  :hover {
    background-color: #16a34a;
  }
`
